export default __webpack_public_path__ + "static/media/activity-active.9d61e912.svg";